"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OS = exports.SubscriptionType = exports.SourceType = exports.DeviceType = void 0;
/*
 * This is the basic structure for the user-session event catcher
 * and this will most likley change.
 * If we do changes here, we will have to extend the utils where we
 * should check for these props.
 */
var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Other"] = 1] = "Other";
    DeviceType[DeviceType["Computer"] = 2] = "Computer";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var SourceType;
(function (SourceType) {
    SourceType[SourceType["Web"] = 1] = "Web";
    SourceType[SourceType["App"] = 2] = "App";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType[SubscriptionType["Free"] = 1] = "Free";
    SubscriptionType[SubscriptionType["Premium"] = 2] = "Premium";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var OS;
(function (OS) {
    OS[OS["Other"] = 1] = "Other";
    OS[OS["Windows"] = 2] = "Windows";
    OS[OS["MacOs"] = 3] = "MacOs";
    OS[OS["Android"] = 4] = "Android";
    OS[OS["IOS"] = 5] = "IOS";
})(OS = exports.OS || (exports.OS = {}));
//# sourceMappingURL=UserSessionEvent.js.map